import { DataTable } from "@/components/admin"
import Empty from "@/components/fornya/empty"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import { Button } from "@/components/ui/button"
import {
  Bath,
  BedDouble,
  BrushCleaning,
  CookingPot,
  DoorOpen,
  Toilet,
  Warehouse,
} from "lucide-react"
import { Identifier, useGetMany, useRedirect } from "ra-core"
import { ReactNode } from "react"
const RoomCard = ({
  id,
  title,
  type,
  surface,
  // windows,
  // balconies,
  children,
  mode,
  material_ids,
}: {
  id: Identifier
  title: string
  type?: string
  status: string
  surface: number
  windows: number
  balconies: number
  mode?: string
  children?: ReactNode
  material_ids?: Array<{ mid: number }>
}) => {
  const redirect = useRedirect()
  const mids = material_ids?.map(m => m.mid)

  const { data, isPending } = useGetMany("materials", { ids: mids })
  return (
    <Accordion
      type="single"
      collapsible
      className="w-full"
      defaultValue="item-2"
    >
      <AccordionItem
        value={id.toString()}
        className="data-[state=open]:bg-accent rounded-md border-none px-5 transition-colors duration-200"
      >
        <AccordionTrigger className="">
          <li key={id} className="flex items-start gap-4">
            <Avatar>
              <AvatarFallback className="bg-indigo-500/10 text-indigo-500">
                {type === "room" && <DoorOpen className="size-5" />}
                {type === "bathroom" && <Bath className="size-5" />}
                {type === "wc" && <Toilet className="size-5" />}
                {type === "garage" && <Warehouse className="size-5" />}
                {type === "bedroom" && <BedDouble className="size-5" />}
                {type === "kitchen" && <CookingPot className="size-5" />}
              </AvatarFallback>
            </Avatar>
            <div className="flex flex-1 flex-col">
              <div className="text-sm font-medium">{title}</div>
              <p className="text-muted-foreground text-xs">
                {surface}
                <sup>m2</sup>
              </p>
            </div>
          </li>
        </AccordionTrigger>
        <AccordionContent className="flex flex-col gap-4 text-balance">
          {/* <div className="text-muted-foreground flex flex-wrap gap-3 text-sm ml-2">
            <div className="flex items-center gap-1">
              <Blinds className="size-3" />
              {windows}
            </div>
            <div className="flex items-center gap-1">
              <PanelTopDashed className="size-3" />
              {balconies}
            </div>
          </div> */}
          <DataTable
            resource="books"
            data={data}
            total={mids?.length}
            isPending={isPending}
            empty={
              <Empty source="materials" mode="show" icon={<BrushCleaning />} />
            }
          >
            <DataTable.Col source="name" />
            <DataTable.Col source="category" />
            <DataTable.Col source="type" />
            <DataTable.Col source="unit" />
            <DataTable.Col source="cost_per_unit" />
            <DataTable.Col source="carbon_footprint" />
          </DataTable>
          {children}
          {mode === "edit" && (
            <Button
              type="button"
              className="relative mx-3"
              size="sm"
              variant="outline"
              onClick={() => redirect(`/rooms/${id}/edit`)}
            >
              Edit
            </Button>
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}

export default RoomCard
